<div class="healthcare-how-it-works">
	<div class="container container-mobile">
		<div class="healthcare-how-panel">
			<div class="healthcare-how-header">
				<img
					src="../../../assets/images/healthcare-how-header-icon.svg"
					alt=""
					class="healthcare-how-header-icon"
					aria-hidden="true" />
				<div class="healthcare-how-header-text">
					<h2>How It Works</h2>
					<p class="healthcare-how-subtitle">
						Creating Your Healthcare Directive is Simple and Secure
					</p>
				</div>
			</div>

			<div class="healthcare-how-steps">
				@for (step of steps; track step.number; let i = $index; let last = $last) {
					<div class="healthcare-how-step" [class.healthcare-how-step--last]="last">
						<div class="healthcare-how-timeline">
							<div class="healthcare-how-step-number">{{ step.number }}</div>
							@if (!last) {
								<div class="healthcare-how-timeline-line" aria-hidden="true"></div>
							}
						</div>

						<div class="healthcare-how-step-content">
							<div class="healthcare-how-icon-wrap">
								<img [src]="step.iconSrc" [alt]="step.iconAlt" class="healthcare-how-icon" />
							</div>
							<div class="healthcare-how-step-text">
								<h3 class="healthcare-how-step-title">{{ step.title }}</h3>
								<p class="healthcare-how-step-description">{{ step.description }}</p>
							</div>
						</div>
					</div>
				}
			</div>

			<div class="healthcare-how-cta">
				<button type="button" class="healthcare-how-cta-btn" (click)="onCtaClick()">
					Create Your Free Healthcare Directive
				</button>
			</div>
		</div>
	</div>
</div>
